import React from 'react';

import Content from '../components/Content';
import PreloadLink from '../components/PreloadLink.js';

const NewFooter = ({ entry }) => {
  return (
    <div className="Site-new-footer">
      <div className="Site-new-footer-text">
        <Content modifier={'landing'} html={entry.text} />
      </div>
      <nav>
        <ul>
          <li className="hover-link">
            <PreloadLink to="/projects">Projects</PreloadLink>
          </li>
          <li className="hover-link">
            <PreloadLink to="/information">About</PreloadLink>
          </li>
          <li className="hover-link m-only" onClick={() => this.hideNav()}>
            <a href="mailto:seb@villagegreen.studio">Enquiries</a>
          </li>
          <li className="hover-link m-only" onClick={() => this.hideNav()}>
            <a
              href="https://www.instagram.com/villagegreen.studio/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
          </li>
        </ul>
      </nav>

      <div className="Site-new-footer-address">
        <Content modifier={'landing'} html={entry.contactText} />
      </div>
    </div>
  );
};

export default NewFooter;



// WEBPACK FOOTER //
// ./src/js/components/NewFooter.jsx